import React, { useEffect, useRef, useState } from 'react'
import { Html5Qrcode } from 'html5-qrcode'
import { X } from 'lucide-react'
import Button from './ui/Button'

interface Props {
  open: boolean
  onClose: () => void
  onDecode: (text: string) => void
}

const SCANNER_ELEMENT_ID = 'dumper-qr-scanner'

const QRScannerModal: React.FC<Props> = ({ open, onClose, onDecode }) => {
  const scannerRef = useRef<Html5Qrcode | null>(null)
  const [error, setError] = useState<string | null>(null)
  const [starting, setStarting] = useState(false)

  useEffect(() => {
    if (!open) return
    let mounted = true
    setError(null)
    setStarting(true)

    const scanner = new Html5Qrcode(SCANNER_ELEMENT_ID, { verbose: false })
    scannerRef.current = scanner

    scanner
      .start(
        { facingMode: 'environment' },
        { fps: 10, qrbox: { width: 240, height: 240 } },
        (decodedText) => {
          if (!mounted) return
          onDecode(decodedText)
          scanner.stop().catch(() => undefined)
        },
        () => undefined,
      )
      .then(() => mounted && setStarting(false))
      .catch((err) => {
        if (!mounted) return
        setStarting(false)
        setError(err?.message || 'No se pudo iniciar la cámara')
      })

    return () => {
      mounted = false
      scanner.stop().catch(() => undefined)
      scanner.clear()
      scannerRef.current = null
    }
  }, [open, onDecode])

  if (!open) return null

  return (
    <div className="fixed inset-0 z-50 bg-black/80 flex items-center justify-center p-4">
      <div className="bg-white rounded-lg w-full max-w-md overflow-hidden">
        <div className="flex items-center justify-between px-4 py-3 border-b">
          <h3 className="font-semibold text-gray-900">Escanear QR volqueta</h3>
          <Button variant="ghost" size="icon" onClick={onClose} title="Cerrar">
            <X className="h-4 w-4" />
          </Button>
        </div>
        <div className="p-3">
          <div id={SCANNER_ELEMENT_ID} className="w-full" />
          {starting && <p className="text-sm text-gray-500 mt-2">Iniciando cámara…</p>}
          {error && <p className="text-sm text-retri-red mt-2">{error}</p>}
        </div>
      </div>
    </div>
  )
}

export default QRScannerModal
